import createOptimisticBalancesAtom from './optimistic-balances.js';
export const optimisticBalancesAtomDefinition = {
    id: 'optimisticBalancesAtom',
    type: 'atom',
    factory: createOptimisticBalancesAtom,
    dependencies: [],
    public: true,
};
